<template>
	<div class="app-side-navigation">
		<div class="is-sticky">
			<div
				v-for="({ title, menu }, index) in navigation"
				:key="index"
				class="nav-section"
			>
				<h5 v-if="title" class="nav-section__title">{{ title }}</h5>
				<slot></slot>
				<ul>
					<li v-for="{ name, id, link } in menu" :key="id">
						<router-link class="nav-section__link" :to="link">{{
							name
						}}</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "AppSideNav",
	props: {
		navigation: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss">
.app-side-navigation {
	&.column {
		width: $app-side-navigation-width;
		background-color: $app-side-navigation-bkgd-color;
		flex: none;

		@include widescreen() {
			width: $app-side-navigation-width-widescreen;
		}
	}
	.nav-section {
		margin-top: 1rem;
		&:first-child {
			margin-top: 2.5rem;
		}

		&__title {
			font-size: $size-5;
			font-weight: $weight-semibold;
			padding: 0.25rem 1rem;
		}

		&__link {
			display: block;
			margin: 0.3125rem 0;
			padding: 0.1875rem 0.75rem;
			font-weight: 600;
			color: $nav-section-link-color;
			border-left: 2px solid transparent;

			&.router-link-exact-active {
				border-left-color: $nav-section-link-border-color;
				color: $nav-section-link-active-color;
			}
		}
	}
}
</style>
